import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnimatedCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_78_14797)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "animated-checkmark",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 4,
				width: 18,
				height: 18,
				rx: 9,
				fill: "#49B7A1"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M11.3333 15.3166L9.01667 13L8.22778 13.7833L11.3333 16.8888L18 10.2222L17.2167 9.43884L11.3333 15.3166Z",
				fill: "white"
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "animated-checkmark-sparks",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 12.6079,
					y: 22.0039,
					width: .784424,
					height: 3.56702,
					rx: .392212,
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 16.4319,
					y: 21.3652,
					width: .784424,
					height: 3.58608,
					rx: .392212,
					transform: "rotate(-30 16.4319 21.3652)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 7.60742,
					y: 1.61914,
					width: .784424,
					height: 3.58573,
					rx: .392212,
					transform: "rotate(-22.1669 7.60742 1.61914)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 18.2197,
					y: 1.54358,
					width: .784424,
					height: 3.57958,
					rx: .392212,
					transform: "rotate(30 18.2197 1.54358)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 24.3022,
					y: 7.59253,
					width: .784424,
					height: 3.54194,
					rx: .392212,
					transform: "rotate(63.5836 24.3022 7.59253)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 24.6187,
					y: 17.8712,
					width: .784424,
					height: 3.55732,
					rx: .392212,
					transform: "rotate(120 24.6187 17.8712)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8.22754,
					y: 24.6777,
					width: .784424,
					height: 3.57147,
					rx: .392212,
					transform: "rotate(-150 8.22754 24.6777)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.90576,
					y: 18.8536,
					width: .784424,
					height: 3.56405,
					rx: .392212,
					transform: "rotate(-120 1.90576 18.8536)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1.34644,
					y: 8.1062,
					width: .784424,
					height: 3.62692,
					rx: .392212,
					transform: "rotate(-62.0243 1.34644 8.1062)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 12.6079,
					y: .429077,
					width: .784424,
					height: 3.57092,
					rx: .392212,
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 25.5708,
					y: 12.7716,
					width: .784424,
					height: 3.57104,
					rx: .392212,
					transform: "rotate(90 25.5708 12.7716)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 21.6113,
					y: 3.83813,
					width: .784424,
					height: 3.56574,
					rx: .392212,
					transform: "rotate(45 21.6113 3.83813)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 6.42017,
					y: 19.1519,
					width: .784424,
					height: 3.5892,
					rx: .392212,
					transform: "rotate(45 6.42017 19.1519)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 6.88916,
					y: 6.3938,
					width: .784424,
					height: 3.61441,
					rx: .392212,
					transform: "rotate(135 6.88916 6.3938)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 22.2095,
					y: 21.5044,
					width: .784424,
					height: 3.5181,
					rx: .392212,
					transform: "rotate(135 22.2095 21.5044)",
					fill: "#49B7A1"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 3.9917,
					y: 12.7716,
					width: .784424,
					height: 3.56262,
					rx: .392212,
					transform: "rotate(90 3.9917 12.7716)",
					fill: "#49B7A1"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_78_14797",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("style", { children: "\n            :root {\n            --first-step-checkmark: 800ms;\n            }\n            @keyframes sparks {\n            0% {transform: scale(0); opacity: 0.8;}\n            60% {transform: scale(0.8); opacity:1;}\n            100% {transform: scale(1); opacity:0;}\n            }\n            #animated-checkmark-sparks{\n            animation: sparks var(--first-step-checkmark) forwards ease-out;\n            transform-origin: center;\n            transform-box: fill-box;\n            }\n            @keyframes check {\n            0% {transform: scale(0); opacity: 0;}\n            30% {transform: scale(0); opacity: 0;}\n            100% {transform: scale(1); opacity: 1;}\n            }\n            #animated-checkmark{\n            animation: check var(--first-step-checkmark) forwards ease-out ;\n            transform-origin: center;\n            transform-box: fill-box;\n            }\n        " })] })]
});
export default SvgAnimatedCheckmark;
